import { API_ENDPOINT, isServerApiError } from "@cede/utils";
import type { SelfRegisterFormData } from "@/store/selfRegisterFormStore";
import { apiHelper } from "@/utils/api";
import { useMutation } from "@tanstack/react-query";

export type SubmitSelfRegisterRequestPayload = SelfRegisterFormData & {
  correlationId: string;
};

export const useSubmitSelfRegisterRequest = () => {
  return useMutation({
    mutationFn: async (payload: SubmitSelfRegisterRequestPayload) => {
      const { correlationId, ...formData } = payload;

      const result = await apiHelper.post(API_ENDPOINT.HUB_SELF_REGISTER_CAMPAIGNS_SUBMIT, {
        bodyParams: formData,
        headers: {
          correlationId, // Override apiHelper's auto-generated correlation ID
        },
      });

      if (isServerApiError(result)) {
        throw new Error(result.message || "Failed to submit request");
      }

      return result;
    },
  });
};
